var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "box-item" }, [
      _c("h3", { staticClass: "approve_title" }, [
        _vm._v(_vm._s(_vm.$t("SUBTITLE.EUR.COMP.USER.INFO")))
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "approve_table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", [
              _vm._v(
                _vm._s(_vm.$t("FIELD.GLOBAL.ID")) +
                  "(" +
                  _vm._s(_vm.$t("FIELD.GLOBAL.EMAIL")) +
                  ")"
              )
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.userEmail))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.PROFILE.COMPANY.NAME")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.companyName))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.NUMBER")))
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.companyRegNo))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.CONTACT.PHONE.NUMBER")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.phoneNumber))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.FIRST.NAME")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.contactFirstName))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.LAST.NAME")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.contactLastName))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.POSTAL.CODE")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.zipCode))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.COMP.ADDR")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.companyAddress))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.COMPANY.WEBSITE.ADDRESS")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.companyWebAddress))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.INSURANCE.POLICY")))]),
            _vm._v(" "),
            _vm.userInfo.fileLength1 > 0
              ? _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "link_attch",
                      attrs: { href: "JavaScript:" },
                      on: {
                        click: function($event) {
                          return _vm.downloadFile("1")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "ico_attach" }),
                      _vm._v(_vm._s(_vm.userInfo.fileName1))
                    ]
                  ),
                  _vm._v(
                    " (" +
                      _vm._s(_vm._f("numberFormat")(_vm.userInfo.fileLength1)) +
                      "KB)\n                    "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.APE.CODES")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.userInfo.apeCodes))]),
            _vm._v(" "),
            _c("th", [
              _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.FILE")))
            ]),
            _vm._v(" "),
            _vm.userInfo.fileLength2 > 0
              ? _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "link_attch",
                      attrs: { href: "JavaScript:" },
                      on: {
                        click: function($event) {
                          return _vm.downloadFile("2")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "ico_attach" }),
                      _vm._v(_vm._s(_vm.userInfo.fileName2))
                    ]
                  ),
                  _vm._v(
                    " (" +
                      _vm._s(_vm._f("numberFormat")(_vm.userInfo.fileLength2)) +
                      "KB)\n                    "
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "list-item" }, [
      _c("div", { staticClass: "item-left" }, [
        _c("h3", { staticClass: "approve_title" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.AUTHREQ.REQUEST")))
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "approve_table" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.REQUEST.DATE")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.REQ_DT))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.REQ.TYPE")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.REQ_TYPE_NM))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.REQUEST.MODEL.CODE")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.MODEL_CD))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.MAJOR.PRODUCT.CATEGORY")))
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.CATE_MAIN_NM))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.SUB.PRODUCT.CATEGORY")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.CATE_SUB_NM))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.REQUESTED.CONTENTS")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.SEL_CNTNTS))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.RECENT.REQUESTED.PRODUCT")))
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.isPrevCategory))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.RELATED.CONTENTS.EXISTS")))
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.CNTNTS_EXIST))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.PREVIOUS.APPROVAL")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.PRE_APPROVAL))])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-right" }, [
        _c("h3", { staticClass: "approve_title" }, [
          _vm._v(_vm._s(_vm.$t("FIELD.EUR.APPR.REJT.INFO")))
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "approve_table" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.CONTS.SEND.YN")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.CONT_SEND_YN))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.APPROVAL.STATUS")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.STATUS_NM))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.FIRST.APPROVER")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.APR_FRST_APPROVER))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.1ST.APPROVAL.DATE")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.APR_FRST_DT))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.SECOND.APPROVER")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.APR_SCND_APPROVER))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.2ND.APPROVAL.DATE")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.APR_SCND_DT))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.ADMIN.REJECT.REASON")))]),
              _vm._v(" "),
              _c("td", [
                _vm.reqtInfo.REJECT_REASON_CD
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm.reqtInfo.REJECT_REASON_CD) +
                          ": " +
                          _vm._s(_vm.reqtInfo.REJECT_REASON_NM)
                      )
                    ])
                  : _c("span", [_vm._v("N/A")])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.EUR.DETAIL.REJECT.REASON")))
              ]),
              _vm._v(" "),
              _c("td", [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.reqtInfo.REJ_REASON,
                      expression: "reqtInfo.REJ_REASON"
                    }
                  ],
                  staticClass: "view_textarea",
                  attrs: { readonly: "" },
                  domProps: { value: _vm.reqtInfo.REJ_REASON },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.reqtInfo, "REJ_REASON", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.REJECT.DATE")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.reqtInfo.REJECT_DT))])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn_wrap_full topLine" }, [
      _c(
        "a",
        {
          staticClass: "btn_white",
          attrs: { href: "JavaScript:" },
          on: { click: _vm.goListBack }
        },
        [_vm._v("List")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "270px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "270px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "290px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "200px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a79898", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a79898","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/admin/ReqApprHistoryDetail.vue
// module id = W1hF
// module chunks = 0